import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useHasUnipileAccount = () => {
	const [hasUnipileAccount, setHasUnipileAccount] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<string | null>(null);

	const check = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const { data, error } = await supabase.functions.invoke('unipile-manager?command=get-active-accounts-for-user', {
				method: 'GET'
			});

			if (error) {
				setHasUnipileAccount(false);
				setError(error.message || 'Edge function error');
				return;
			}

			if (data && Array.isArray(data)) {
				const activeAccounts = data.filter((a: any) => a && a.active === true);
				setHasUnipileAccount(activeAccounts.length > 0);
			} else {
				setHasUnipileAccount(false);
			}
		} catch (err: any) {
			setHasUnipileAccount(false);
			setError(err?.message || 'Failed to check unipile accounts');
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		check();
	}, [check]);

	return {
		hasUnipileAccount,
		loading,
		error,
		refetch: check,
	};
};
